import { Grid, Box, Divider } from '@material-ui/core'

import { Page, Container } from 'components'

import {
  Menu,
  OnPage,
  ButtonBaseComponent,
  Title,
  Paragraph,
  Section,
} from '../../components'

import Home from 'images/documentation/platform/home.png'

import { routes } from 'Routes'

const IntroductionPlatform = () => {
  const onPage = [
    ['#d-introducao', 'Introdução'],
    ['#d-funcionalidadeDisponiveis', 'Funcionalidades Disponíveis'],
  ]
  // const Code = ({ children }) => {
  //   return (
  //     <span
  //       style={{
  //         backgroundColor: '#e2f4f9',
  //         border: '1px solid #63bbdb',
  //         textTransform: 'lowercase',
  //         padding: '1px',
  //         fontSize: '12px',
  //         fontWeight: 400,
  //         width: 'auto',
  //         borderRadius: '4px',
  //       }}
  //     >
  //       {children}
  //     </span>
  //   )
  // }

  return (
    <Page title="Introdução">
      <Container maxWidth="md">
        <Box style={{ marginBottom: '40px' }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <Menu />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Box style={{ marginBottom: '40px' }}>
                <Title variant="h5" id="d-introducao" subtitle="Plataforma">
                  Introdução
                </Title>
                <Paragraph>
                  A página inicial da Superfin reúne todos os recursos
                  essenciais para facilitar sua gestão financeira. Nela, você
                  pode acessar funcionalidades como:
                  <br />
                  <br />
                  <img
                    src={Home}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Página inicial da plataforma Superfin"
                  />
                  <br />
                  <br />
                  <Box ml={10}>
                    <ul>
                      <li>Visualização do saldo e recebíveis futuros;</li>
                      <li>Cobranças avulsas e recorrentes;</li>
                      <li>Gerenciamento de transações e últimas transações;</li>
                      <li>Planos e assinaturas;</li>
                      <li>Relatórios detalhados;</li>
                      <li>Solicitação de saques;</li>
                      <li>Gestão de contas bancárias;</li>
                      <li>Configurações personalizáveis.</li>
                    </ul>
                  </Box>
                </Paragraph>
              </Box>
              <Divider />
              <Section>
                <Title variant="h6" id="d-funcionalidadeDisponiveis">
                  Funcionalidades Disponíveis
                </Title>
                <Paragraph>
                  <Box ml={10}>
                    <ul>
                      <li>Cobranças avulsas;</li>
                      <li>Cobranças recorrentes;</li>
                      <li>Transações;</li>
                      <li>Assinaturas;</li>
                      <li>Planos;</li>
                      <li>Saques;</li>
                      <li>Bancos.</li>
                      <li>...e muito mais!</li>
                    </ul>
                  </Box>
                </Paragraph>
              </Section>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ButtonBaseComponent
                    nextName="Cobrança Avulsa"
                    previousName="Início"
                    previousRoute={routes.documentation.main}
                    nextRoute={routes.documentation.chargePlatform}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <OnPage page={onPage} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default IntroductionPlatform
